var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconEdit = function SvgIconEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.42 2.832a.873.873 0 1 1 .001 1.746H3.74a.787.787 0 0 0-.787.786v10.803c0 .434.352.786.786.786h11.632a.786.786 0 0 0 .786-.785v-3.682a.872.872 0 0 1 1.746 0v3.682a2.534 2.534 0 0 1-2.531 2.531H3.739a2.532 2.532 0 0 1-2.53-2.531V5.363a2.531 2.531 0 0 1 2.53-2.53zm10.07-1.04.116.108.486.487c.869.87.905 2.256.109 3.17l-.109.116-7.396 7.397a.884.884 0 0 1-.278.187l-.107.037-3.511.973a.871.871 0 0 1-.85-.225.87.87 0 0 1-.246-.748l.022-.102.972-3.511c.03-.11.081-.21.15-.3l.074-.085L14.32 1.9a2.324 2.324 0 0 1 3.17-.109zm-9.5 9.76-.17.62.62-.172-.45-.448zm6.213-7.068L8.797 9.89l1.304 1.304 5.405-5.405-1.304-1.304zm1.5-1.458-.078.047-.072.061-.116.115 1.305 1.304.115-.114a.578.578 0 0 0 .061-.746l-.06-.072-.487-.487a.58.58 0 0 0-.668-.108z",
    fill: "none",
    fillRule: "evenodd"
  })));
};

export default SvgIconEdit;